import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from '@features/auth/authSlice';
import chatModeReducer from '@features/chat/chatModeSlice';
import documentsReducer from '@features/documents/documentsSlice';
import drbfmReducer from '@features/drbfm/drbfmSlice';
import searchReducer from '@features/search/searchSlice';
import featureFlagsReducer from '@features/featureFlags/featureFlagsSlice';
import uiReducer from '@features/ui/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    chatMode: chatModeReducer,
    documents: documentsReducer,
    drbfm: drbfmReducer,
    featureFlags: featureFlagsReducer,
    search: searchReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['documents/uploadProgress'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
